import {
  Conversation,
  CustomPartConversationMessage,
} from '@stripe-internal/conversations-client';
import {useMessagePartComponents} from '../../MessagePartComponentContext';
import {DefaultMessagePartComponentsMap} from '../../MessagePartComponentProvider';
import {TextMessageRow} from './TextMessageRow';
import {devLog} from '../../../helpers/dev';

type CustomPartMessageRowProps = {
  conversation: Conversation;
  message: CustomPartConversationMessage;
  animated?: boolean;
  isLive?: boolean;
  disableInteraction?: boolean;
  avatar?: React.ReactNode | null | undefined;
};

export function CustomPartMessageRow({
  conversation,
  message,
  animated,
  isLive,
  disableInteraction,
  avatar,
}: CustomPartMessageRowProps) {
  const registry = useMessagePartComponents();
  const {part} = message;
  const Component =
    registry[part.type] ?? DefaultMessagePartComponentsMap[part.type];

  if (!Component) {
    devLog('Conversation message part warning', {
      conversationId: conversation.id,
      messageId: message.id,
      partId: part.id,
      partType: part.type,
      warning: 'Missing message part component',
    });
    const text = part.content.text.length > 0 ? part.content.text : null;
    if (text !== null) {
      return (
        <TextMessageRow
          conversation={conversation}
          message={{
            id: message.id,
            participant: message.participant,
            timestamp: message.timestamp,
            status: message.status,
            nonce: message.nonce,
            errors: message.errors,
            data: message.data,
            type: 'text-conversation-message',
            text,
            ...(message.responseId === undefined
              ? {}
              : {responseId: message.responseId}),
            ...(message.feedback === undefined
              ? {}
              : {feedback: message.feedback}),
          }}
          avatar={avatar}
        />
      );
    }

    return null;
  }

  return (
    <Component
      conversation={conversation}
      message={message}
      part={part}
      animated={animated}
      isLive={isLive}
      disableInteraction={disableInteraction}
      avatar={avatar}
    />
  );
}
